var map = {
	"./bg_image_1.png": "c034",
	"./bg_image_2.png": "3be2",
	"./bg_image_3.png": "9dfa",
	"./bg_image_4.png": "cdc2",
	"./bg_image_5.png": "8b35",
	"./bg_image_6.png": "7f99",
	"./bg_image_home.png": "fc21",
	"./休闲观光.png": "8ffc",
	"./去城市周边探索自然及野生动物.png": "df0c",
	"./地图3_2_c.png": "8a93",
	"./地图A-哈雷摩托游.png": "d643",
	"./地图A-河滨休闲餐厅.png": "9c38",
	"./地图A-皇家植物园.png": "7964",
	"./地图A-皮艇游.png": "584c",
	"./地图A-观景摩天轮.png": "ab17",
	"./地图A-野生动物园.png": "ca15",
	"./地图B-涂鸦游览.png": "bd76",
	"./地图B-移动影像中心.png": "7d47",
	"./地图B-维州国立美术馆.png": "da6e",
	"./地图B-论坛剧院.png": "ce27",
	"./地图C-厨艺学习.png": "df17",
	"./地图C-品味咖啡.png": "75f4",
	"./地图C-小巷主题晚餐.png": "f160",
	"./地图C-时尚之都购物与美食.png": "db4f",
	"./地图C-极致高空晚宴.png": "a8e8",
	"./地图C-维多利亚女皇市场.png": "55e6",
	"./地图D-亚拉谷热气球.png": "c359",
	"./地图D-企鹅归巢.png": "d1ff",
	"./地图D-罗富酒庄.png": "5897",
	"./地图D-菲利普岛自然公园.png": "5885",
	"./地图D-雷纳果园.png": "3a7f",
	"./文化参观.png": "1f64",
	"./文字背景1.png": "fd93",
	"./文字背景2.png": "4424",
	"./标签B-州立图书馆.png": "9396",
	"./美食购物.png": "dd0b",
	"./路线图页-地图A.png": "f543",
	"./路线图页-地图B.png": "a5a1",
	"./路线图页-地图C.png": "3a57",
	"./路线图页-地图D.png": "1598"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";